var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container container-narrow" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.tickets") } }),
        _vm.emptyPage
          ? _c("article", { staticClass: "message is-success" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("tickets.empty"))),
              ]),
            ])
          : _vm._e(),
        _vm.errorPage
          ? _c("article", { staticClass: "message is-danger" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.error"))),
              ]),
            ])
          : _vm._e(),
        _c("p", { staticClass: "control has-text-centered margin-bottom-md" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary button-right-icon",
              attrs: { type: "button" },
              on: { click: _vm.openTicketModal },
            },
            [
              _vm._v(_vm._s(_vm.$t("button.new_ticket"))),
              _c("span", { staticClass: "icon feather" }, [_c("plus-icon")], 1),
            ]
          ),
        ]),
        _vm._l(_vm.tickets, function (ticket) {
          return _c("div", { key: ticket.uuid, staticClass: "box" }, [
            _c("div", { staticClass: "ticket-header" }, [
              _c("strong", { staticClass: "is-size-5-desktop" }, [
                _vm._v(_vm._s(ticket.subject)),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("tickets.last_update", {
                      time: _vm.getDate(ticket.updated),
                    })
                  )
                ),
              ]),
            ]),
            _c("p", { staticClass: "margin-top-sm" }, [
              _vm._v(_vm._s(ticket.message)),
            ]),
            ticket.reply
              ? _c(
                  "p",
                  { staticClass: "margin-top-md padding-xs ticket-reply-box" },
                  [
                    _c("span", { staticClass: "ticket-reply" }, [
                      _vm._v(_vm._s(_vm.$t("tickets.reply").toUpperCase())),
                    ]),
                    _c("br"),
                    _vm._v(_vm._s(ticket.reply)),
                  ]
                )
              : _vm._e(),
          ])
        }),
        _c(
          "modal-comp",
          { ref: "modal", attrs: { title: _vm.$t("button.new_ticket") } },
          [
            _c("div", { staticClass: "form-container" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("label.subject"))),
                ]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.subject,
                        expression: "subject",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "text", maxlength: "100" },
                    domProps: { value: _vm.subject },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.subject = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("label.message"))),
                ]),
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.message,
                        expression: "message",
                      },
                    ],
                    staticClass: "textarea",
                    attrs: { maxlength: "4000" },
                    domProps: { value: _vm.message },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.message = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control has-text-centered" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      class: _vm.buttonClass,
                      attrs: { type: "button" },
                      on: { click: _vm.submitTicket },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("button.submit"))),
                      _c(
                        "span",
                        { staticClass: "icon feather" },
                        [_c("chevron-right-icon")],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm.errorSubject
                ? _c(
                    "article",
                    {
                      staticClass: "message is-danger",
                      attrs: { transition: "fade" },
                    },
                    [
                      _c("div", { staticClass: "message-body" }, [
                        _vm._v(_vm._s(_vm.$t("alert.missing_subject"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.errorMessage
                ? _c(
                    "article",
                    {
                      staticClass: "message is-danger",
                      attrs: { transition: "fade" },
                    },
                    [
                      _c("div", { staticClass: "message-body" }, [
                        _vm._v(_vm._s(_vm.$t("alert.missing_message"))),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }